export const formatResizedUrl = (imageUrl: string, width: number, height?: number): string => {
	// Width and height values can be based off of screen size (and thus could be a non-integer)
	const constantWidth = Math.floor(width);
	const constantHeight = height ? Math.floor(height) : height;

	const sizerPath = constantHeight ? `${constantWidth}x${constantHeight}` : `${constantWidth}`;
	const urlId = imageUrl.replace('https://assets.calm.com/', `https://assets.calm.com/${sizerPath}/`);
	return urlId;
};
